
const images = [
    {
        "status": true,
        "message": "Image Added!",
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/Jxe6eASdEiBmvNfF8oBRdKsCSppawSMWsr3w6ODs.png",
        "title": "How Gift Cards Work",
        "key": 'how_gift_cards_work'
    },
    {
        "status": true,
        "message": "Image Added!",
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/nO1HGS8tD3qewKVPTybIfrP76GVoqpobzFJIcYe1.jpg",
        "title": "advanturePoster",
        "key": 'advanturePoster'
    },
    {
        "status": true,
        "message": "Image Added!",
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/wFFTRAJfzKYmBRRNJgZvpPLS2LuOQmfxTvldhtuT.webp",
        "title": "groceryPoster",
        "key": 'groceryPoster'
    },
    {
        "status": true,
        "message": "Image Added!",
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/WlC21Le6KOfvqwnTm9MllTq8SIr1uTM3MKeu0oH4.webp",
        "title": "foodPoster",
        "key": 'foodPoster'
    },
    {
        "status": true,
        "message": "Image Added!",
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/38ASrAjQkCS1rQvgHB3IXKozm0yuz3nGrHEz4Thp.jpg",
        "title": "app-store-banner",
        "key": 'app-store-banner'
    },
    {
        "status": true,
        "message": "Image Added!",
        "image": "https://99paisa.s3.ap-south-1.amazonaws.com/fund--request/BkuQha277jBMPsAzFTjbPdEqrnaBymy4WxkBxVrN.webp",
        "title": "all-Category-banner",
        "key": 'all-Category-banner'
    }
]

export const giveMeImage = (name) => {
    const data = images.find((item) => item.key === name);
    if (!data) {
        return '';
    }
    return data
}
